import { Box, Stack, Text, Radio, Divider } from "@mantine/core";
import { GetCoursesParams } from "../../types/api";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

interface Props {
  credentials: GetCoursesParams;
  setCredentials: React.Dispatch<React.SetStateAction<GetCoursesParams>>;
  onClose: () => void;
  handleSearch: () => void;
}

export const SortPopoverContent: React.FC<Props> = ({
  credentials,
  setCredentials,
  onClose,
  handleSearch,
}) => {
  const { t } = useTranslation();
  const [shouldSearch, setShouldSearch] = useState(false);

  useEffect(() => {
    if (shouldSearch) {
      handleSearch();
      setShouldSearch(false);
    }
  }, [credentials, shouldSearch]);

  const handleChange = (value: string) => {
    setCredentials((prev) => ({
      ...prev,
      ordering: value,
    }));
    setShouldSearch(true);
    onClose();
  };

  return (
    <Box>
      <Text fw={500} mb="sm">
        {t("sort.title")}
      </Text>
      <Stack gap="xs">
        <Radio.Group value={credentials.ordering || ""} onChange={handleChange}>
          <Stack gap="xs" px="xs">
            <Text size="sm" c="dimmed">
              {t("sort.rating_group")}
            </Text>
            <Radio value="-rating" label={t("sort.by_rating_desc")} />
            <Radio value="rating" label={t("sort.by_rating_asc")} />
          </Stack>

          <Divider my="xs" />

          <Stack gap="xs" px="xs">
            <Text size="sm" c="dimmed">
              {t("sort.price_group")}
            </Text>
            <Radio value="price" label={t("sort.price_asc")} />
            <Radio value="-price" label={t("sort.price_desc")} />
          </Stack>

          <Divider my="xs" />

          <Stack gap="xs" px="xs">
            <Text size="sm" c="dimmed">
              {t("sort.free_group")}
            </Text>
            <Radio value="-is_free" label={t("sort.free_first")} />
            <Radio value="is_free" label={t("sort.free_last")} />
          </Stack>
        </Radio.Group>
      </Stack>
    </Box>
  );
};
